import { useState } from 'react';
import { Autocomplete, Box, Chip, TextField } from '@mui/material';
import { useCreate, useDelete, useList, useOne, useResourceParams } from '@refinedev/core';

import { ATTACKIQ_ID } from '@attackiq/constants/platform';

import { Scenario, Tag } from '../../../types';

const ScenarioTags = () => {
  const { id: scenarioId } = useResourceParams();
  const [tagSearchValue, setTagSearchValue] = useState('');
  const { mutateAsync: createAsync } = useCreate();
  const { mutateAsync: deleteAsync } = useDelete();

  const {
    result: scenarioObj,

    query: { isLoading, refetch: refetchScenarioTags }
  } = useOne<Scenario>({
    resource: 'scenarios',
    id: scenarioId as string
  });

  const { result: tags } = useList<Tag>({
    resource: 'tags',

    pagination: {
      pageSize: 20
    },

    filters: [
      {
        field: 'name__icontains',
        operator: 'contains',
        value: tagSearchValue
      }
    ]
  });

  const addNewScenarioTag = async (scenarioId: string, tagId: string) => {
    try {
      await createAsync({
        resource: 'scenario_tags',
        values: {
          company: ATTACKIQ_ID,
          scenario: scenarioId,
          tag: tagId
        }
      });
    } catch (e) {
      console.error(e);
    } finally {
      refetchScenarioTags();
    }
  };

  const removeScenarioTags = async (scenarioTagId: string) => {
    try {
      await deleteAsync({
        resource: 'scenario_tags',
        id: scenarioTagId
      });
    } catch (e) {
      console.error(e);
    } finally {
      refetchScenarioTags();
    }
  };

  const tagOptions = tags?.data?.filter(tag => !scenarioObj?.tags.find(scenarioTag => scenarioTag.id === tag.id)) || [];

  if (isLoading) {
    return null;
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 1
        }}
      >
        {scenarioObj?.tags.map(scenarioTag => (
          <Chip
            onDelete={() => removeScenarioTags(scenarioTag.scenario_tag_id)}
            size="small"
            key={scenarioTag.id}
            label={`${scenarioTag.tag_set_name}: ${scenarioTag.display_name}`}
          />
        ))}
      </Box>
      <Autocomplete
        disablePortal
        options={tagOptions}
        getOptionLabel={option => `${option.tag_set_name}: ${option.display_name}`}
        value={null}
        inputValue={tagSearchValue}
        onInputChange={(_event, value) => setTagSearchValue(value)}
        renderInput={params => <TextField {...params} label="Add tag" />}
        onChange={(_event, newlySelectedTag) => {
          addNewScenarioTag(scenarioId as string, newlySelectedTag?.id as string);
          setTagSearchValue('');
        }}
      />
    </Box>
  );
};

export default ScenarioTags;
